export enum DocumentTypeKinds {
  /**
   * 昔の管理外文書がバグで0になっている
   */
  Invalid = 0,
  /**
   * 通常文書
   */
  Normal = 1,
  /**
   * ワークフロー文書
   */
  Workflow = 2,
  /**
   * ワークフロー依頼書
   */
  RequestSheet = 3,
  /**
   * 管理外文書
   */
  Unmanaged = 4,
}
